/**
 CSS files are static by nature and don’t support dynamic logic.
 Current approach leverages TypeScript for theming, media queries, and utility functions (e.g., hoverBoxShadow, focusDoubleBoxShadow), which cannot be replicated in plain CSS.
 To retain dynamic behavior, need to keep the .css.ts approach for more flexibility and type safety.
 */

import { theme as foundationTheme, utils } from "@nel-ui/foundations";
import { Styles } from "@nel-ui/tooling-styling";
import { theme as typographyTheme } from "@nel-ui/typography-styles";

const { focusDoubleBoxShadow, hoverBoxShadow, isolate, mq } = utils;

const theme = { ...foundationTheme, ...typographyTheme };
const mediaQuerySmall = "@media (max-width: 30rem)";
const mediaQueryMed = "@media(min-width: 30rem) and (max-width: 33.125rem)";

const styles: Styles = {
  reset: isolate(),
  toggleSwitchContainer: {
    color: theme.colourTextBody,
    marginTop: "1rem",
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    width: "13.5625rem",
    [mediaQuerySmall]: {
      width: "100%",
    },
    [mediaQueryMed]: {
      width: "11.6875rem",
    },
  },

  // Label
  toggleSwitchLabel: {
    ...theme.subtitleSmall01,
    [mq.viewportMd as string]: {
      ...theme.subtitleLarge01,
    },
  },

  // Button
  toggleSwitchButtonContainer: {
    border: "none",
    borderRadius: "1.5rem",
    cursor: theme.cursorInteraction,
    display: "flex",
    height: "2.25rem",
    padding: "0",
    width: "3.5rem",

    "&:hover": hoverBoxShadow(),
    "&:focus": focusDoubleBoxShadow(),
  },

  toggleSwitchButtonOn: {
    backgroundColor: theme.interactionBlue600Default,
  },

  toggleSwitchButtonOff: {
    backgroundColor: theme.colourBlack50,
  },

  // Circle
  toggleSwitchButtonCircle: {
    alignItems: "center",
    backgroundColor: theme.colourBrand03,
    border: "none",
    borderRadius: "6.25rem",
    color: theme.colourBrand01,
    display: "flex",
    justifyContent: "center",
    height: "1.75rem",
    marginTop: "0.25rem",
    marginBottom: "0.25rem",
    transition: "all 0.2s",
    width: "1.75rem",

    "&$toggleSwitchButtonCircleOff": {
      marginLeft: "0.25rem",
    },
    "&$toggleSwitchButtonCircleOn": {
      marginLeft: "1.5rem",
    },
  },

  toggleSwitchButtonCircleOff: {},
  toggleSwitchButtonCircleOn: {},
};

export default styles;
